import { useState } from 'react';
import { AiOutlineCheck, AiOutlineClose, AiOutlineCopy } from 'react-icons/ai';
import { useNavigate } from 'react-router';
import SuccessImage from "../../assets/Business_win.gif";

const AssessmentRedirectPopup = ({ url, onClose }) => {
    const [isCopied, setIsCopied] = useState(false);
    const navigate = useNavigate()

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(url);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000); // Reset after 2 seconds
    };

    const handleStartAssessment = (e) => {
        e.preventDefault();
        window.open(url, '_blank');
        navigate("/student-report")
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="relative w-[90%] md:w-[500px] bg-white rounded-lg shadow-lg px-6 py-6 transition-all duration-300">
                {/* Close Icon */}
                {/* <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-xl transition-colors"
                    aria-label="Close"
                >
                    <AiOutlineClose />
                </button> */}

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-800 text-center mb-5">
                    Proceed to Assessment
                </h3>

                <div className='text-center flex justify-center mb-6'>
                    <img src={SuccessImage} alt="success-img" className='h-28 text-center' />
                </div>

                {/* URL with copy functionality */}
                <div className="mb-6">
                    <p className="text-sm text-gray-600 mb-2 font-medium text-center">Your assessment link:</p>
                    <div className="flex items-center border border-gray-300 rounded-md p-2 bg-gray-50 hover:border-violet-400 transition-colors">
                        <p className="text-sm text-gray-800 truncate flex-1 pr-2">{url}</p>
                        <button
                            onClick={handleCopyToClipboard}
                            className="ml-2 p-1.5 rounded hover:bg-gray-200 transition-colors group relative"
                            title="Copy to clipboard"
                        >
                            {isCopied ? (
                                <AiOutlineCheck className="text-green-600" />
                            ) : (
                                <AiOutlineCopy className="text-gray-500 group-hover:text-violet-600" />
                            )}
                            {/* Tooltip feedback */}
                            {isCopied && (
                                <span className="absolute -top-8 -right-2 bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap">
                                    Link Copied!
                                </span>
                            )}
                        </button>
                    </div>
                    <div className='w-full text-center mt-4 '>

                        <span className=' w-full text-sm'>Click "Start Assessment Now" to begin. We've also sent the link to your registered email for your convenience</span>
                    </div>
                </div>

                {/* Start Assessment Button */}
                <div className="flex justify-center">
                    <button
                        onClick={handleStartAssessment}
                        className="bg-violet-600 text-white hover:bg-violet-700 px-8 py-2.5 rounded-md font-medium flex items-center transition-colors hover:shadow-md"
                    >
                        Start Assessment Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AssessmentRedirectPopup;